import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { apiSlice } from "./api/apiSlice";
import authReducer from "./slices/authSlice";
import guestReducer from "./slices/guestSlice";
import ordersReducer from "./slices/ordersSlice";
import themeReducer from "./slices/themeSlice";

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    // hotelFeaturesApi and notificationsApi use apiSlice.injectEndpoints — no separate reducers needed
    auth: authReducer,
    guest: guestReducer,
    orders: ordersReducer,
    theme: themeReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
        ignoredPaths: ["register"],
      },
      immutableCheck: {
        ignoredPaths: ["register"],
      },
    }).concat(apiSlice.middleware),
  devTools: import.meta.env.DEV,
});

setupListeners(store.dispatch);

export const { getState, dispatch } = store;
